import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-screen-loader-component',
  templateUrl: './screen-loader.component.html',
  styleUrl: './screen-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScreenLoaderComponent {
  public isLoading = input<boolean>(false);
  public layout = input<'fixed' | 'absolute'>('fixed');
}
